import React,{useEffect,useState} from 'react'
import { useNavigate } from "react-router-dom";
import Header from '../../components/Header';
import MenuAccordian from '../../components/Accordion';

const Menu = ()=> {

    const navigate = useNavigate();

    useEffect(()=>{
        if(localStorage.getItem('token')===null || localStorage.getItem('token')===undefined){
            navigate('/login');
          }
        document.title = 'Home - I-Stem Library'
      },[]);

 return (
    <div className='containerr'>
        <Header/>
        <p className="display-3">Welcome to Nclude.Ai</p>
        <MenuAccordian/>
    </div>
 )
}

export default Menu